@if (show) {
<div class="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center px-3 sm:px-6 lg:ps-[280px]">
  <div class="bg-white {{width}} rounded-[20px] sm:rounded-[24px] max-h-[90vh] flex flex-col relative w-full">

    <!-- HEADER -->
    <div class="flex items-center justify-between px-6 sm:px-8 py-4 sm:py-6 border-b">
      <h2 class="text-lg sm:text-xl font-bold text-[#0B0D5C]">{{ title | translate }}</h2>
      <button class="h-9 w-9 flex items-center justify-center rounded-full border" (click)="close()">✕</button>
    </div>

    <!-- BODY -->
    <div class="overflow-y-auto px-6 sm:px-8 py-6 flex-1">

      @if (type === 'form') {
        <app-dynamic-form [fields]="fields" [model]="data" [readonly]="readonly" [showFileDownload]="showFileDownload"
          (formSubmit)="onFormSubmit($event)"
          (formChange)="formChange.emit($event)">
        </app-dynamic-form>
      } @else if (type === 'confirm') {
        <!-- ✅ Confirm message -->
        <p class="text-base text-gray-700 text-center py-4">{{ message | translate }}</p>
      } @else {
        <ng-content></ng-content>
      }

    </div>

    <!-- FOOTER -->
    @if (type === 'form') {
      <div class="px-6 sm:px-8 py-4 border-t flex justify-end flex-col sm:flex-row gap-3 sm:gap-6">
        <button class="btn-primary" (click)="triggerSubmit()">{{ (saveLabel || 'COMMON.SAVE') | translate }}</button>
        <button class="btn-danger" (click)="close()">{{ (closeLabel || 'COMMON.CANCEL') | translate }}</button>
      </div>
    } @else if (type === 'confirm') {
      <!-- ✅ Confirm footer -->
      <div class="px-6 sm:px-8 py-4 border-t flex justify-end flex-col sm:flex-row gap-3 sm:gap-6">
        <button class="btn-primary" (click)="onConfirm()">{{ confirmText | translate }}</button>
        <button class="btn-danger" (click)="close()">{{ cancelText | translate }}</button>
      </div>
    } @else if (type === 'custom' && showCustomFooter) {
      <!-- Optional fixed footer for custom-content popups -->
      <div class="px-6 sm:px-8 py-4 border-t flex justify-end flex-col sm:flex-row gap-3 sm:gap-6">
        @if (primaryButtonText) {
          <button
            class="btn-primary disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="primaryButtonDisabled"
            (click)="primaryClick.emit()"
          >
            {{ primaryButtonText | translate }}
          </button>
        }
        <button class="btn-danger" (click)="close()">{{ (closeLabel || 'COMMON.CANCEL') | translate }}</button>
      </div>
    }
  </div>
</div>
}